import React from "react";
import Header from "./components/Header";
import { AppRoutes } from "./routes";
import makeStyles from "@mui/styles/makeStyles";
import "./app.css";
import "./styles.scss";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 100,
    width: "100vw",
    [theme.breakpoints.down("md")]: {
      paddingTop: 50,
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 50,
    },
  },
}));

const App = (props) => {
  const classes = useStyles();
  const loader = useSelector((state) => state.loader);

  return (
    <div className={classes.root}>
      {loader.open && <Loader />}
      <Header />
      <div className="mainappdiv">
        <AppRoutes />
      </div>

      <Footer />
    </div>
  );
};

export default App;
